<template>
  <div
    class="modal custom-modal fade"
    id="edit_contact"
    role="dialog"
    :showUpdate.sync="showUpdate"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Edit Contact</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <form @submit.prevent="updateContact">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <label class="col-form-label">
                    First Name
                    <span class="text-danger">*</span>
                  </label>
                  <input v-model="formUpdateContact.first_name" class="form-control" type="text" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label class="col-form-label">Last Name</label>
                  <input v-model="formUpdateContact.last_name" class="form-control" type="text" />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label>
                Email Address
                <!-- <span class="text-danger">*</span> -->
              </label>
              <input v-model="formUpdateContact.email" class="form-control" type="email" />
            </div>
            <div class="form-group">
              <label>
                Contact Number
                <span class="text-danger">*</span>
              </label>
              <input v-model="formUpdateContact.phone_number" class="form-control" type="text" />
            </div>
            <div class="form-group">
              <!-- {{formCreateContact}} -->
              <label class="d-block">Group</label>
              <div class="task-wrapper">
                <div class="task-list-container">
                  <div class="task-list-body">
                    <ul id="task-list">
                      <template v-for="rowG in groupListArr">
                        <li
                          v-on:click="selectGroup(rowG.id);"
                          v-bind:id="'up-'+rowG.id"
                          class="task"
                          :key="rowG.id"
                        >
                          <div class="task-container">
                            <span class="task-action-btn task-check">
                              <span class="action-circle large complete-btn" title="Select">
                                <i class="material-icons">check</i>
                              </span>
                            </span>
                            <span class="task-label" contenteditable="false">{{rowG.name}}</span>
                          </div>
                        </li>
                      </template>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";

export default {
  components: {
    Skeleton
  },
  data() {
    return {
      loading: false,
      formUpdateContact: {
        id: "",
        email: "",
        phone_number: "",
        first_name: "",
        last_name: "",
        list_id: []
      }
    };
  },
  computed: {
    groupListArr() {
      return this.$store.state.contact.groupListArr;
    }
  },
  watch: {
    showUpdate: {
      handler: function(val, oldVal) {
        // console.log("val", val);
        // console.log("oldVal", oldVal);
        if (val != "") {
          this.viewContact(val);
        }
      },
      deep: true
    }
  },
  props: {
    filterContactListGroup: {
      type: Function
    },
    showUpdate: {
      type: String,
      default: ""
    }
  },
  methods: {
    hasClass(element, className) {
      return (
        (" " + element.className + " ").indexOf(" " + className + " ") > -1
      );
    },
    resetSelected() {
      if (this.groupListArr.length > 0) {
        this.groupListArr.forEach(function(row, index) {
          // console.log("vaaaa", value);
          // if (this.hasClass("up-" + row.id, "completed")) {
          var element = document.getElementById("up-" + row.id);
          element.classList.remove("completed");
          // }
        });
      }
    },
    async viewContact(id) {
      await this.$store.dispatch("contact/viewContact", id).then(response => {
        this.resetSelected();
        var { contact_list, contact_rel } = response;
        this.formUpdateContact = contact_list;
        this.formUpdateContact.list_id = [];

        if (contact_rel.length > 0) {
          // this.formUpdateContact.list_id = contact_rel;
          var that = this;
          contact_rel.forEach(function(value, index) {
            that.selectGroup(value);
            console.log("valueeee", value);
          });
        }

        console.log("resview", response);
        console.log("formUpdateContact", this.formUpdateContact);
      });
    },
    async updateContact() {
      this.formUpdateContact.phone_number=this.formUpdateContact.phone_number.toString()
      await this.$store
        .dispatch("contact/updateContact", this.formUpdateContact)
        .then(response => {
          this.formUpdateContact.list_id.forEach((value, index) => {
            var element = document.getElementById(value);
            element.classList.remove("completed");
          });
          // this.formUpdateContact = {
          //   id: "",
          //   email: "",
          //   phone_number: "",
          //   first_name: "",
          //   last_name: "",
          //   list_id: []
          // };

          this.$fire({
            title: "Success",
            text: "Data updated successfully",
            type: "success",
            timer: 1000
          }).then(r => {
            this.filterContactListGroup();
          });
        });
      // .catch(error => {
      //   console.log("errrrrr", error);
      //   this.$fire({
      //     title: "Error",
      //     text: error.msg,
      //     type: "error",
      //     timer: 1000
      //   }).then(r => {});
      // });
    },
    async selectGroup(id) {
      console.log("selgr", id);
      var element = document.getElementById("up-" + id);
      if (this.formUpdateContact.list_id.length > 0) {
        var isFound = false;
        var indexFound = -1;
        await this.formUpdateContact.list_id.forEach((value, index) => {
          if (value === id) {
            indexFound = index;
          }
        });

        if (indexFound >= 0) {
          element.classList.remove("completed");
          this.formUpdateContact.list_id.splice(indexFound, 1);
        } else {
          // this.$refs
          element.classList.add("completed");
          this.formUpdateContact.list_id.push(id);
        }
      } else {
        element.classList.add("completed");
        this.formUpdateContact.list_id.push(id);
      }
    }
  },
  async created() {},
  async mounted() {},
  name: "update-contacts"
};
</script>


// WEBPACK FOOTER //
// src/views/contacts/updateContact.vue